import useFeatureFlagByNameKey from '@/shared/hooks/useFeatureFlagByNameKey/useFeatureFlagByNameKey';

const useGamifiactionRewardsAttributesFilters = () => {
  const { valueFeatureFlag, loading } = useFeatureFlagByNameKey(
    'GAMIFICATION_FILTERS_TAGS',
  );

  return {
    isGamificationFiltersTagsFeatureFlagActive: valueFeatureFlag,
    isLoadingGamificationFiltersTagsFeatureFlag: loading,
  };
};

export default useGamifiactionRewardsAttributesFilters;
